module.exports = __webpack_public_path__ + "img/whatsapp_white.60450d7d.webp";